import { UAParser } from "ua-parser-js";

class UserMediaService {
  static async checkCameraPermission() {
    try {
      const permissions = await navigator.permissions.query({
        name: "camera",
      });
      return permissions.state;
    } catch (error) {
      console.error("Error checking camera permission:", error);
      return "error";
    }
  }

  static async askCameraPermission() {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true });
      return "granted";
    } catch (error) {
      console.error("Error requesting camera permission:", error);
      if (error instanceof DOMException) {
        return error.name === "NotAllowedError" ? "denied" : "error";
      }
      return "error";
    }
  }

  static async checkMicrophonePermission() {
    try {
      const permissions = await navigator.permissions.query({
        name: "microphone",
      });
      return permissions.state;
    } catch (error) {
      console.error("Error checking microphone permission:", error);
      return "error";
    }
  }

  static async askMicrophonePermission() {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      return "granted";
    } catch (error) {
      console.error("Error requesting microphone permission:", error);
      if (error instanceof DOMException) {
        return error.name === "NotAllowedError" ? "denied" : "error";
      }
      return "error";
    }
  }

  static async hasCamera() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.some((device) => device.kind === "videoinput");
    } catch (error) {
      console.error("Error checking for camera availability:", error);
      return false;
    }
  }

  static async hasMicrophone() {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.some((device) => device.kind === "audioinput");
    } catch (error) {
      console.error("Error checking for microphone availability:", error);
      return false;
    }
  }

  static async getUserAgents() {
    try {
      const parser = new UAParser();
      const result = parser.getResult() || {};
  
      return {
        ua: result.ua || navigator.userAgent || null,
        browser_name: result.browser?.name || null,
        browser_version: result.browser?.version || null,
        os_name: result.os?.name || null,
        os_version: result.os?.version || null,
        device_type_name: result.device?.type || "Desktop",
        screen_height:
          typeof window !== "undefined" ? window.screen?.height || null : null,
        screen_width:
          typeof window !== "undefined" ? window.screen?.width || null : null,
      };
    } catch (error) {
      console.error("getUserAgents error:", error);
      return {};
    }
  }
  
  static async getLocation() {
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by this browser.");
      return { latitude: null, longitude: null };
    }

    return new Promise((resolve) => {
      let isResolved = false;

      const timeoutId = setTimeout(() => {
        if (!isResolved) {
          console.warn("User didn't respond in time for location permission.");
          resolve({ latitude: null, longitude: null });
        }
      }, 5000);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (!isResolved) {
            clearTimeout(timeoutId);
            isResolved = true;
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          }
        },
        (error) => {
          if (!isResolved) {
            console.error("Error getting location:", error);
            clearTimeout(timeoutId);
            isResolved = true;
            resolve({ latitude: null, longitude: null });
          }
        }
      );
    });
  }
}

export default UserMediaService;
